module.exports = __webpack_public_path__ + "media/bark01.e04751df.mp3";